const reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
const reHasRegExpChar = new RegExp(reRegExpChar.source);

// Fallback for browsers without RegExp.escape support (no polyfill is loaded for this).
// Remove once RegExp.escape (https://github.com/tc39/proposal-regex-escaping) is supported by all target browsers.
const escapeRegExpFallback = (value = ''): string =>
  reHasRegExpChar.test(value) ? value.replace(reRegExpChar, '\\$&') : value;

export const escapeRegExp = (value = ''): string =>
  // eslint-disable-next-line baseline-js/use-baseline
  typeof RegExp.escape === 'function' ? RegExp.escape(value) : escapeRegExpFallback(value);
